import type { TFunction } from 'i18next'
import type { ImprovementAction, QualityRisk } from '~/gql/quality/quality'
import { ACTION_STATUS_KEYS, ORIGIN_KEYS, RISK_STATUS_KEYS } from './quality-labels'

type Csv = { headers: string[], rows: string[][] }
type FormatDate = (value: unknown) => string

/** Le journal des actions en CSV (#328), pour l'auditeur : origine, porteur, échéance, effet. */
export function actionsCsv(actions: readonly ImprovementAction[], t: TFunction, formatDate: FormatDate): Csv {
  const date = (value: unknown) => (value ? formatDate(value) : '')
  return {
    headers: [
      t('quality.actions.column.createdAt'),
      t('quality.actions.column.origin'),
      t('quality.column.title'),
      t('quality.actions.column.description'),
      t('quality.column.owner'),
      t('quality.actions.column.dueDate'),
      t('quality.column.status'),
      t('quality.actions.column.effect'),
      t('quality.actions.column.doneAt'),
    ],
    rows: actions.map(a => [
      date(a.createdAt),
      t(ORIGIN_KEYS[a.origin]),
      a.title,
      a.description,
      a.owner ?? '',
      date(a.dueDate),
      t(ACTION_STATUS_KEYS[a.status]),
      a.effect ?? '',
      date(a.doneAt),
    ]),
  }
}

/** Le registre des risques en CSV (#328) : cotes, gravité, mesure, état, dernière revue. */
export function risksCsv(risks: readonly QualityRisk[], t: TFunction, formatDate: FormatDate): Csv {
  return {
    headers: [
      t('quality.column.title'),
      t('quality.risks.column.description'),
      t('quality.risks.column.likelihood'),
      t('quality.risks.column.impact'),
      t('quality.risks.column.severity'),
      t('quality.risks.column.mitigation'),
      t('quality.column.owner'),
      t('quality.column.status'),
      t('quality.risks.column.reviewedAt'),
    ],
    rows: risks.map(r => [
      r.title,
      r.description,
      String(r.likelihood),
      String(r.impact),
      String(r.severity),
      r.mitigation ?? '',
      r.owner ?? '',
      t(RISK_STATUS_KEYS[r.status]),
      formatDate(r.updatedAt),
    ]),
  }
}
